export default __webpack_public_path__ + "static/media/vector.4ea8c4fe.png";